export enum CATEGORIES_ROUTES {
  ROOT = "categories",
  LIST = "list",
  EDIT = "edit",
  ADDPRODUCTS = "add-products",
  NEW = "new",
}

export const INITIALVALUES = {
  id: "",
  name: "",
  description: "",
  imagesDetail: [],
  productIds: [],
  imagesForm: [],
  products: [],
};

export const OTHERSCATEGORIES = 'otras categorias';
